import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { cancelLabRequest } from '../../../ReduxSlices/LabRequests/labRequests';
import LabTestList from './labTestList';

const LabRequestCard = ({ request }) => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    if (
      window.confirm(
        `Cancel ${request.lab_test_type?.name || 'this lab request'}?`
      )
    ) {
      dispatch(cancelLabRequest(request.id));
    }
  };

const humanize = (str) =>
  str.replace(/_/g, ' ');

  return (
    <div className="prescription-grid">
     <div> 
      <p><strong>Test:</strong> {request.lab_test_type?.name}</p>
      <p><strong>Doctor Notes:</strong> {request.doctor_notes || 'None'}</p>
      <p><strong>Status:</strong> {humanize(request.status)}</p>
      <p><strong>Requested At:</strong> {new Date(request.created_at).toLocaleString()}</p>
        {request.status !== 'canceled' && (
          <button
            type="button"
            onClick={handleCancel}
            className="mt-2 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
          >
            Cancel Request
          </button>
        )}
    </div>
      {/* Nested LabTests */}
      {request.lab_tests && request.lab_tests.length > 0 && (
        <div className="mt-4">
          <h4 className="text-sm font-semibold mb-2">Tests</h4>
          <LabTestList labTests={request.lab_tests} loading={false} />
        </div>
      )}
    </div>
  );
};

LabRequestCard.propTypes = {
  request: PropTypes.shape({
    id: PropTypes.number.isRequired,
    patient: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
    consultation_id: PropTypes.number.isRequired,
    doctor_notes: PropTypes.string,
    status: PropTypes.string.isRequired,
    bill_status: PropTypes.string,
    created_at: PropTypes.string.isRequired,
    lab_tests: PropTypes.array,
  }).isRequired,
};

export default LabRequestCard;
